import React, { Component } from "react";
import { func } from "prop-types";
import { changeLanguage, getMessage } from "CONFIG/i18n";
import { Row, Col, Button, InputGroup, FormControl } from "react-bootstrap";
import { Input } from "reactstrap";
import QRCode from "qrcode.react";
import validator from "validator";
import ChangeLanguage from "COMPONENTS/CommonComponents/ChangeLanguage/ChangeLanguage";

import MfaErrorModal from "./MFAErrorModal";
import MfaEnableModal from "./MFAEnableModal";
import { USER_ROLES, MFA_CONST } from "../../Utils/Constants";
import { CONFIG, ERROR, DEFAULT_LANGUAGE, API_URL, LANGUAGE } from "UTILS/Constants";
import { getSSOLoginUrl } from "UTILS/Utility";
import { getTimeInMillisec } from "UTILS/DateUtils";

import "./Login.less";
import logo from "../../Assets/Images/img_signin_bg_logo.webp";
import DisplayPictureSuperAdmin from "../../Assets/Images/img_signin_super_admin.webp";
import DisplayPictureAdmin from "../../Assets/Images/img_signin_admin.webp";
import DisplayPictureAgent from "../../Assets/Images/img_signin_agent.webp";
import mfaLockImage from "../../Assets/Images/img_mfa_lock.webp";

class Login extends Component {
  static propTypes = {
    handleLoginClick: func
  };
  state = {
    userDetails: {
      username: "",
      password: "",
    },
    errorMessage: "",
    networkError: "",
    selectedLanguage: DEFAULT_LANGUAGE,
    isDisabled: false,
    mfaKey: "",
    authButton: false,
    errorMessageMfa: "",
    isMfaSetup: false,
    isMfaLogin:false,
    isShowMfaErrorScreen: false,
    isShowMfaEnableScreen: false,
    qrCodeUrl: "",
    mfaSecretKey: "",
    qrCodeTimer: null,
    isResetQrCodeTimer: false,
  };

  componentDidMount() {
    console.log(`timestamp: Login rendered at ${getTimeInMillisec()}, milliseconds: ${new Date().getTime()}`);
    window.addEventListener('online', () => {
      let errorMessage = this.state.errorMessage == ERROR.NETWORK_ERROR ? "" : this.state.errorMessage
      this.setState({
        errorMessage: errorMessage
      })
    });
    if(this.props.language !== LANGUAGE.EN.name){
      changeLanguage(LANGUAGE.JA.name);
    }
  }

  handleInputChange = name => event => {
    let userDetails = this.state.userDetails;
    if (name === "username") {
      userDetails[name] = event.target.value.trim();
    }
    else {
      userDetails[name] = event.target.value;
    }
    this.setState({
      userDetails: userDetails,
      errorMessage: ""
    });
  };
  enterPressed = event => {
    var code = event.keyCode || event.which;
    if (code === 13) {
      this.handleLoginClick();
    }
  };
  handleLoginClick = () => {
    if (this.isValidLoginInfo(this.state.userDetails)) {
      const uriIdentifier = this.props.uriIdentifier.replace(/^\//, '').replace(/\/$/, '');
      const userDetails = this.state.userDetails;
      if (uriIdentifier) {
        userDetails.uriIdentifier = uriIdentifier;
      }
      this.props.handleLoginClick(userDetails);
    }
  };

  isValidLoginInfo = userInfo => {
    if (userInfo.username === "" && userInfo.password === "") {
      this.setState({
        errorMessage: "USERNAME_PASSWORD_EMPTY_MESSAGE"
      });
      return false;
    }
    return true;
  };

  handleEnableLogin = () => {
    if (this.state.userName === false && this.state.password === false) {
      this.setState({
        isDisabled: false
      });
    } else {
      this.setState({
        isDisabled: true
      });
    }
  };

  onSelectChange = selectedLanguage => {
    this.props.setLanguageAction(selectedLanguage);
    this.setState({ selectedLanguage: selectedLanguage });
  };

  getLoginMessageByRole = () => {
    switch (this.props.roleByPath) {
      case USER_ROLES.ADMIN:
        return getMessage("ADMIN_SIGN_IN");
      case USER_ROLES.SUPER_ADMIN:
        return getMessage("SUPER_ADMIN_SIGN_IN");
      default:
        return getMessage("AGENT_SIGN_IN")
    }
  }

  getLoginImageByRole = () => {
    switch (this.props.roleByPath) {
      case USER_ROLES.ADMIN:
        return DisplayPictureAdmin;
      case USER_ROLES.SUPER_ADMIN:
        return DisplayPictureSuperAdmin;
      default:
        return DisplayPictureAgent;
    }
  }

  handleMfaKeyInputChange = name => event  => {
    let set_value = event.target.value;
    if (!set_value.match(/^\d{0,6}$/)) {
      set_value = this.state[name];
    }
    this.setState({
      [name]: set_value,
      authButton: set_value.length >= 6 ? true : false,
      errorMessage: ""
    });
  };

  enterPressedMfa = event => {
    let code = event.keyCode || event.which;
    if (code === 13) {
      if (this.state.authButton) {
        this.handleAuthClick();
      }
    }
  };

  handleAuthClick = () => {
    this.props.handleMfaClick(this.state.mfaKey, this.props.mfaToken, this.state.isMfaSetup);
  };

  focusMfaKeyInput = () => {
    if (this.state.isMfaSetup) {
      document.getElementById('MfaSetupInput').focus();
    } else if (this.state.isMfaLogin) {
      document.getElementById('MfaLoginInput').focus();
    }
  };

  componentDidUpdate(prevProps) {
    if (prevProps.isMfaSetup !== this.props.isMfaSetup){
      this.setState({ isMfaSetup: this.props.isMfaSetup });
      // the setup screen startup
      if (!prevProps.isMfaSetup) {
        this.setState({
          qrCodeTimer: setTimeout(() => {
            if (!this.props.isShowMfaErrorScreen && !this.props.isShowMfaEnableScreen) {
              this.setState({ 
                mfaKey: "",
                authButton: false,
              });
              this.focusMfaKeyInput();
              this.props.handleShowMfaErrorScreen("MFA_ERROR_TIMED_OUT");
            }
          }, MFA_CONST.QRCODE_TIMEOUT),
        });
      }
    }
    if (prevProps.isMfaLogin !== this.props.isMfaLogin){
      this.setState({ isMfaLogin: this.props.isMfaLogin });
    }
    if (prevProps.networkError !== this.props.networkError) {
      switch (this.props.networkError) {
        case "MFA_ERROR_ALREADY_AUTHED":
        case "MFA_ERROR_TIMED_OUT":
        case "MFA_ERROR_LOCK_CREDENTIALS":
        case "MFA_ERROR_NOT_AUTHORIZED":
        case "MFA_ERROR_INVALID_MFA_INFO":
          this.setState({ 
            mfaKey: "",
            authButton: false,
            errorMessageMfa: this.props.networkError,
          });
          this.focusMfaKeyInput();
          break;
        case "MFA_ERROR_INVALID_CREDENTIALS":
          this.setState({
            mfaKey: "" ,
            authButton: false,
            errorMessage: this.props.networkError
          });
          this.focusMfaKeyInput();
          break;
        case "INVALID_USER":
          if (this.props.isMfaSetup || this.props.isMfaLogin) {
            this.setState({ 
              mfaKey: "",
              authButton: false,
              errorMessageMfa: "MFA_ERROR_INVALID_USER",
            });
            this.focusMfaKeyInput();
          } else {
            this.setState({ errorMessage: this.props.networkError });
            break;
          }
          break;
        default:
          this.setState({ errorMessage: this.props.networkError });
          break;
      }
    }
    if (prevProps.qrCodeUrl !== this.props.qrCodeUrl){
      this.setState({ qrCodeUrl: this.props.qrCodeUrl });
    }
    if (prevProps.mfaSecretKey !== this.props.mfaSecretKey){
      this.setState({ mfaSecretKey: this.props.mfaSecretKey });
    }
    if (prevProps.isShowMfaErrorScreen !== this.props.isShowMfaErrorScreen){
      this.setState({ isShowMfaErrorScreen: this.props.isShowMfaErrorScreen });
    }
    if (prevProps.isShowMfaEnableScreen !== this.props.isShowMfaEnableScreen){
      this.setState({ isShowMfaEnableScreen: this.props.isShowMfaEnableScreen });
    }
    if (prevProps.isResetQrCodeTimer !== this.props.isResetQrCodeTimer){
      this.setState({ isResetQrCodeTimer: this.props.isResetQrCodeTimer });
      if (this.props.isResetQrCodeTimer) {
        if (this.state.qrCodeTimer) {
          clearTimeout(this.state.qrCodeTimer);
          this.setState({ qrCodeTimer: null });
        }
      }
    }    
  }

  componentWillUnmount() {
    if (this.state.qrCodeTimer) {
      clearTimeout(this.state.qrCodeTimer);
      this.setState({ qrCodeTimer: null });
    }
  }

  render() {
    // var ssoURL = getSSOLoginUrl(this.props.ssoDetails);
    return (
      <div className="container-fluid SignIn">
        <div className="languageSelection">
          <div className="noMargin">
            <ChangeLanguage
              onSelectChange={this.onSelectChange}
              language={this.props.language}
            />
          </div>
        </div>
        <Row className="Inner">
          { !this.state.isMfaSetup && <>
            <Col md={7} xs={12} lg={7} xl={7}>
              <img className="SignInPicture" src={this.getLoginImageByRole()} alt="SignIn Picture" />
            </Col>
            <Col md={5} xs={12} lg={5} xl={5} className="SignInContainer">
              <Row>
                <Col md={12} className="text-center">
                  <img className="img-responsive SignInLogo" src={logo} alt="logo" />
                </Col>
              </Row>
              { !this.state.isMfaLogin && <div>
                <Row>
                  <Col md={12} className="text-center">
                    <label className="SignInLabel">{this.getLoginMessageByRole()}</label>
                  </Col>
                </Row>
                <Row className='d-flex'>
                  <Col>
                    <Row>
                      <Col>
                        <label className="SignInUserNameLabel text-left">
                          {getMessage("ACCOUNT_ID")}
                        </label>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <InputGroup>
                          <FormControl
                            type="email"
                            onChange={this.handleInputChange("username")}
                            onKeyPress={this.enterPressed}
                            name="userName"
                            className="SignInUserNameInput"
                            autoFocus
                          />
                        </InputGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <label className="SignInPasswordLabel text-left">
                          {getMessage("PASSWORD")}
                        </label>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <InputGroup>
                          <FormControl
                            type="password"
                            onChange={this.handleInputChange("password")}
                            name="password"
                            className="SignInPasswordInput"
                            onKeyPress={this.enterPressed}
                          />
                        </InputGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={12}>
                        <div className="text-right SignInForgotLabelContainer">
                          <div className="forgotPwd">
                            <span className="cursorPointer"  onClick={() => { this.props.history.push(CONFIG.path.forgotPassword) }}>
                              {getMessage("FORGOT_PASSWORD")}
                            </span>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                  {(this.props.roleByPath === USER_ROLES.AGENT
                    || this.props.roleByPath === USER_ROLES.ADMIN )
                    && this.props.ssoDetails.isSSOEnabled ?
                    <><div className="verticalDivider"></div>
                      <Col md={3} className="singleSignOnContainer p-2">
                        {/* <Button className="bgwhite singleSignOn" onClick={() => { window.location.assign(ssoURL) }}> */}
                        <Button className="bgwhite singleSignOn" onClick={()=>this.props.ssoLoginWithCognito()}>
                          {getMessage("SINGLE_SIGN_ON")}
                        </Button>
                      </Col> </> : null
                  }
                </Row>
                <Row>
                  <Col md={12}>
                    <Button
                      className="customBtn btnSignIn whiteOnClick"
                      onClick={this.handleLoginClick}
                    >
                      {getMessage("SIGN_IN")}
                    </Button>
                    <div className="errors autoHeight">{getMessage(this.state.errorMessage)}</div>
                  </Col>
                </Row>
              </div>}
              { this.state.isMfaLogin && <div>
                <Row className="MfaPaddingTop6Per"></Row>
                <Row>
                  <Col md={12} className="text-center">
                    <img className="mfaLockImage" src={mfaLockImage} />
                    <label className="MfaTitleLabel align-items-center font-weight-bold">{getMessage("MFA_KEY_ENTER_TITLE")}</label>
                  </Col>
                </Row>
                <Row>
                  <label className="MfaMsgLabel text-left autoHeight MfaMarginBottom30">
                    {getMessage("MFA_KEY_ENTER_MSG_1")}</label>
                </Row>
                <Row>
                  <label className="MfaMsgLabel text-left autoHeight">
                    {getMessage("MFA_KEY_ENTER_MSG_2")}</label>
                </Row>
                <Row className='d-flex'>
                  <Col>
                    <Row>
                      <Col>
                        <Input
                          id="MfaLoginInput"
                          className="MfaKeyInput text-center"
                          type="tel"
                          value={this.state.mfaKey}
                          maxLength="6"
                          onChange={this.handleMfaKeyInputChange("mfaKey")}
                          onKeyPress={this.enterPressedMfa}
                          autoFocus
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <Button
                      className="customBtn btnSignIn whiteOnClick"
                      disabled={!this.state.authButton}
                      onClick={this.handleAuthClick}
                    >
                      {getMessage("AUTH_BUTTON")}
                    </Button>
                    <div className="errors autoHeight">{getMessage(this.state.errorMessage)}</div>
                  </Col>
                </Row>
              </div>}
            </Col>
          </>}
          { this.state.isMfaSetup && <div className="mx-auto">
            <Col md={8} xs={12} lg={8} xl={8} className="MfaContainer mx-auto">
              <Row className="MfaPaddingTop6Per"></Row>
              <Row>
                <Col md={12} className="text-center">
                  <img className="mfaLockImage" src={mfaLockImage} />
                  <label className="MfaTitleLabel font-weight-bold">
                    {getMessage("MFA_SETTING_WINDOW_TITLE")}</label>
                </Col>
              </Row>
              <Row className="MfaMarginBottom30"></Row>
              <Row>
                <label className="MfaMsgLabel text-left autoHeight font-weight-bold">
                  {getMessage("MFA_SETTING_EXPLANATION")}</label>
              </Row>
              <Row>
                <label className="MfaMsgLabel text-left autoHeight">
                  {getMessage("MFA_TOTP_APP_INSTALLING")}</label>
              </Row>
              <Row>
                <label className="MfaMsgLabel text-left autoHeight font-weight-bold">
                  {getMessage("MFA_SETTING_PROCEDURE_1")}</label>
              </Row>
              <Row>
                <Col md={12} className="text-center">
                  <QRCode
                    includeMargin={true}
                    id="TotpQrcode"
                    className="TotpQrcode"
                    value={this.state.qrCodeUrl}
                  />
                </Col>
              </Row>
              <Row>
                <label className="MfaMsgLabel autoHeight font-weight-bold"> {getMessage("MFA_SETTING_MFA_KEY")} </label>
              </Row>
              <Row>
                <Col md={12} className="text-center autoHeight">
                  <div className="MfaKeyTextarea text-center font-weight-bold">{this.state.mfaSecretKey}</div>
                </Col>
              </Row>
              <Row>
                <label className="MfaMsgLabel text-left autoHeight font-weight-bold">
                  {getMessage("MFA_SETTING_PROCEDURE_2")}</label>
              </Row>
              <Row className='d-flex'>
                <Col>
                  <Row>
                    <Col>
                      <Input
                        id="MfaSetupInput"
                        className="MfaKeyInput text-center"
                        type="tel"
                        value={this.state.mfaKey}
                        maxLength="6"
                        onChange={this.handleMfaKeyInputChange("mfaKey")}
                        onKeyPress={this.enterPressedMfa}
                        autoFocus
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <Button
                    className="customBtn btnSignIn whiteOnClick"
                    disabled={!this.state.authButton}
                    onClick={this.handleAuthClick}
                  >
                    {getMessage("AUTH_BUTTON")}
                  </Button>
                  <div className="errors autoHeight">{getMessage(this.state.errorMessage)}</div>
                </Col>
              </Row>
            </Col>
          </div>}
          <MfaErrorModal
            show={this.state.isShowMfaErrorScreen}
            handleMfaBackToLoginClick={this.props.handleMfaBackToLoginClick}
            errorMessageMfa={this.state.errorMessageMfa}
          />
          <MfaEnableModal
            show={this.state.isShowMfaEnableScreen}
            handleMfaEnableOkClick={this.props.handleMfaEnableOkClick}
            mfaLoginResponse={this.props.mfaLoginResponse}
          />
        </Row>
      </div>
    );
  }
}
export default Login;
